import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { usePageHeroStyles } from './PageHero.styles';
import { fadeUp, stagger } from '../../../styles/animations';

interface PageHeroProps {
    eyebrow: string;
    title: React.ReactNode;
    subtitle?: string;
}

const PageHero = ({ eyebrow, title, subtitle }: PageHeroProps) => {
    const { classes } = usePageHeroStyles();

    return (
        <Box component="section" className={classes.section}>
            <motion.div
                className={classes.inner}
                initial="hidden"
                animate="visible"
                variants={stagger(0.1)}
            >
                <motion.div variants={fadeUp}>
                    <Typography variant="overline" className={classes.eyebrow}>{eyebrow}</Typography>
                </motion.div>
                <motion.div variants={fadeUp}>
                    <Typography variant="display2" component="h1">{title}</Typography>
                </motion.div>
                {subtitle && (
                    <motion.div variants={fadeUp}>
                        <Typography variant="subtitle1" className={classes.subtitle} sx={{ color: 'fog' }}>
                            {subtitle}
                        </Typography>
                    </motion.div>
                )}
            </motion.div>
        </Box>
    );
};

export default PageHero;
